import { memo } from 'react'
import DisconnectedAudioPlayer from './DisconnectedAudioPlayer'
import useAudioPlayer from 'd2/hooks/useAudioPlayer'
import type { Props } from './types'

const AudioPlayer = memo<Props>(({
  autoPlay,
  hidden,
  loop,
  muted,
  name,
  onDurationChange,
  onPause,
  onPlay,
  preload,
  src,
}) => {
  const {
    currentTime,
    playing,
    setCurrentTime,
    setPlaying,
    togglePlaying,
  } = useAudioPlayer()

  return (
    <DisconnectedAudioPlayer
      autoPlay={autoPlay}
      currentTime={currentTime}
      hidden={hidden}
      loop={loop}
      muted={muted}
      name={name}
      onDurationChange={onDurationChange}
      onPause={onPause}
      onPlay={onPlay}
      playing={playing}
      preload={preload}
      setCurrentTime={setCurrentTime}
      setPlaying={setPlaying}
      src={src}
      togglePlaying={togglePlaying}
    />
  )
})

AudioPlayer.displayName = 'AudioPlayer'

export default AudioPlayer
